export default "__VITE_ASSET__DNAr6Anw__"